import { PathWithId } from "@constellation-academy/epic-ui";

export class CoachPath extends PathWithId<typeof CoachPath> {
	static readonly pathKey = "coachProfile";
	static readonly pathName = "coach-profile";
	static readonly idKey = "coachProfileId";
}
